import type {
  AdminUser,
  CreateAdminUserInput,
  HealthResponse,
  MetaResponse,
  PageResult,
  ResetAdminPasswordInput,
  ResetAdminPasswordResult,
  Role,
  UpdateAdminUserInput,
} from '@quds/shared';
import { apiGet, apiPatch, apiPost } from '@/lib/api';
import { invalidate } from '../invalidation';

export const getApiHealth = () => apiGet<HealthResponse>('/health');
export const getApiMeta = () => apiGet<MetaResponse>('/meta');

export const listRoles = async (): Promise<Role[]> => (await apiGet<{ items: Role[] }>('/roles')).items;
export const listAdminUsers = () => apiGet<PageResult<AdminUser>>('/admin-users', { pageSize: 100 });

export async function createAdminUser(input: CreateAdminUserInput): Promise<AdminUser> {
  const created = await apiPost<AdminUser>('/admin-users', input);
  invalidate();
  return created;
}

export async function updateAdminUser(id: string, input: UpdateAdminUserInput): Promise<AdminUser> {
  const updated = await apiPatch<AdminUser>(`/admin-users/${encodeURIComponent(id)}`, input);
  invalidate();
  return updated;
}

/** Super Admin reset of another admin's password; the API signs them out everywhere. */
export async function resetAdminPassword(id: string, input: ResetAdminPasswordInput): Promise<ResetAdminPasswordResult> {
  const result = await apiPost<ResetAdminPasswordResult>(`/admin-users/${encodeURIComponent(id)}/reset-password`, input);
  invalidate();
  return result;
}
